import { render, staticRenderFns } from "./ChecklistIntegerFieldModule.vue?vue&type=template&id=2efbb364"
import script from "./ChecklistIntegerFieldModule.vue?vue&type=script&lang=ts"
export * from "./ChecklistIntegerFieldModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports